import { Button, Flex, Text, Box, Separator, SubTitle } from "@shared/primitive-components"
import * as styles from "./styles"

type Props = {
  multipleVehiclesAdded: boolean
  onFinish: () => void
}

export const ConnectFleetNotification = ({ onFinish, multipleVehiclesAdded }: Props) => (
  <Flex flexDirection="column" css={styles.root}>
    <Box>
      <SubTitle css={styles.notificationHeading}>CONNECT YOUR FLEET</SubTitle>
      <Separator size="block" color="yellow" />
    </Box>

    <Text css={styles.notificationText}>
      Thank you for adding {multipleVehiclesAdded ? `new vehicles` : `a new vehicle`} to your Flock policy. To ensure
      you can maximise the benefits of your Flock policy, by viewing safety insights and qualifying for rebates, you may
      need to order
      {multipleVehiclesAdded
        ? ` additional telematics devices for these vehicles`
        : ` an additional telematics device for this vehicle`}
      .
    </Text>
    <Flex alignItems="center">
      <Text css={styles.notificationTextWithButton}>
        If you require {multipleVehiclesAdded ? `new telematics devices` : `a new telematics device`} from Matrix,
        please:
      </Text>
      <Button
        css={styles.notificationButton}
        onClick={() => {
          window.open(`https://flockcover.typeform.com/to/eTJUxZJT`, `_blank`)
          onFinish()
        }}
      >
        Click Here
      </Button>
    </Flex>

    <Text css={styles.notificationFooter}>
      For clients utilising a different Telematics Service Provider (TSP), device orders should be made directly through
      your selected provider. If you require additional devices, please reach out to your TSP directly.
    </Text>
  </Flex>
)
